module.exports = __webpack_public_path__ + "static/media/September_2026_4.37cffc64.webp";